import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import CollectionsBlockView from './CollectionsBlock';
import CollectionsBlockSchema from './CollectionsBlockSchema';

interface CollectionsBlockEditProps {
  data: any;
  block: string;
  onChangeBlock: (blockId: string, data: any) => void;
  selected: boolean;
}

const CollectionsBlockEdit: React.FC<CollectionsBlockEditProps> = (props) => {
  const { data, block, onChangeBlock, selected } = props;

  return (
    <>
      <CollectionsBlockView {...props} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={CollectionsBlockSchema}
          title={CollectionsBlockSchema.title}
          onChangeField={(id: string, value: any) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default CollectionsBlockEdit;
